<div class="flex justify-end gap-2">
    <!-- @if (dclCard()?.Responses?.[0]?.NewClientDclID == undefined) {
        <p-button label="Υποβολή" (click)="sendNewClient()" severity="info" />
    } @else {
        <p-button
            label="Έξοδος Οχήματος"
            (click)="completeDCL()"
            severity="warn"
            [disabled]="
                digitalClientCardTypeFormGroup?.controls
                    ?.ProvidedServiceCategory?.value == undefined
            "
        />
    } -->

    <!-- <p-button label="Ακύρωση" severity="secondary" (click)="visible = false" /> -->
    <!-- <p-button label="Αποθήκευση" (click)="onSave()" /> -->
</div>
